/* LIVE */
const  API_URL = 'https://mfu.goalstox.com/admin/api/';
const  BASE_URL = 'https://mfu.goalstox.com/admin';
const  WEB_BASE_URL = 'http://192.168.1.38:3000/';
  
 /* Testing */
//  const  API_URL = 'https://goalstox.codexo.in/admin/api/';
//  const  BASE_URL = 'https://goalstox.codexo.in/admin';
//  const  WEB_BASE_URL = 'http://192.168.1.38:3000/'; 


const CATEGORIES=[];
const themesetting={};
export default { API_URL ,CATEGORIES, themesetting};
